module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/chairdesk/chairdesk.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/chairdesk/chairdesk.png
// module id = 534
// module chunks = 0